module.exports = __webpack_public_path__ + "static/media/bg.a6000a71.png";